import React from "react";

function SearchSelectorCategoryIcon({type}) {
    if (type === "all") {
        return (
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M7 4h10v4H7V4ZM5 8h14v12H5V8Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
                <path d="M9 12h6M9 16h4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
        );
    }

    if (type === "department") {
        return (
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M4 20V10l8-5 8 5v10H4Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
                <path d="M9 20v-5h6v5" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
            </svg>
        );
    }

    if (type === "company") {
        return (
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M3 21h18M6 21V7l6-4 6 4v14" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
                <path d="M9 11h2M13 11h2M9 15h2M13 15h2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
        );
    }

    return (
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M4 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/>
        </svg>
    );
}

export default SearchSelectorCategoryIcon;
